export const KITCHEN_ORDERS_PAGE_SIZE = 25;
